module.exports = __webpack_public_path__ + "static/media/checked-icon-yellow.8412c4e7.svg";